import { fetchGraphQL, fetchGraphQLv2 } from '../Connections';

import {
  getFieldListString
} from './util';


export function queryListRates(variables, fields) {
  const query = `
    query listRates(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listRates(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}


export function queryGetRate(variables, fields) {
  const query = `query getRate($rate_id: String!) {
    getRate(rate_id: $rate_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryCreateRate(variables, fields) {
  const query = `mutation createRate(
    $rate: RateInput!,
    $accessLevelCode: String,
    $fees: [FeeInput],
    $promo_codes: [PromoCodeInput],
    $access_devices: [AccessDeviceInput],
    $sales_limits: [SalesLimitInput]
  ) {
    createRate(
      rate: $rate,
      accessLevelCode: $accessLevelCode,
      fees: $fees,
      promo_codes: $promo_codes,
      access_devices: $access_devices,
      sales_limits: $sales_limits
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryUpdateRate(variables, fields) {
  const query = `mutation updateRate(
    $rate: RateInput!,
    $accessLevelCode: String,
    $fees: [FeeInput],
    $promo_codes: [PromoCodeInput],
    $access_devices: [AccessDeviceInput],
    $sales_limits: [SalesLimitInput]
  ) {
    updateRate(
      rate: $rate,
      accessLevelCode: $accessLevelCode,
      fees: $fees,
      promo_codes: $promo_codes,
      access_devices: $access_devices,
      sales_limits: $sales_limits
    ) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function queryGetRateAccessDevices(variables) {
  const query = `
    mutation getRateAccessDevices(
      $rateId: String!,
      $parkerStartDate: String!
    ) {
      getRateAccessDevices(
        rateId: $rateId,
        parkerStartDate: $parkerStartDate
      ) {
        id,
        required,
        type,
        price,
        tax1,
        tax2,
        tax3,
        tax4
      }
    }
  `;

  return fetchGraphQLv2({ query, variables });
}
